import { Button } from "@/components/ui/button";
import { Lock, Unlock } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { lockVault, useVaultSession } from "@/lib/vault/vaultState";

export default function VaultStatusBadge() {
  const session = useVaultSession();
  const unlocked = !!session;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          onClick={() => { if (unlocked) lockVault(); }}
          data-testid="button-vault-status"
          aria-label={unlocked ? "Vault unlocked — click to lock" : "Vault locked"}
        >
          {unlocked ? <Unlock className="w-4 h-4 text-primary" /> : <Lock className="w-4 h-4 text-muted-foreground" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {unlocked ? "Vault unlocked — click to lock" : "Vault locked"}
      </TooltipContent>
    </Tooltip>
  );
}
